import React, { useEffect, useState } from 'react'
import { TabsLineProps } from './TabsLine.types'
import styles from './TabsLine.module.scss'
import cl from 'classnames'
import { Button } from '../Button'
import { Text1 } from '../Text1'
import { HorizontalLine } from '../HorizontalLine'
import { capitalize } from 'validate.js'

function TabsLineComponent<TabType> (props: TabsLineProps<TabType>) {
  const {
    className,
    style,
    tabs,
    selectedTab,
    capitalizeTabs,
    boldSelectedTab,
    onSelectedTabChange,
    customTabComponent,
    children
  } = props

  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    if (!selectedTab) return
    const index = tabs.findIndex(tab => tab === selectedTab)
    if (index < 0 || index === selectedIndex) return
    setTimeout(() => setSelectedIndex(index), 100)
    // eslint-disable-next-line
  }, [selectedTab])

  useEffect(() => {
    if (!onSelectedTabChange) return
    const newlySelectedTab = tabs[selectedIndex]
    if (newlySelectedTab === selectedTab) return
    onSelectedTabChange(newlySelectedTab)
    // eslint-disable-next-line
  }, [selectedIndex, onSelectedTabChange, tabs])

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <div className={styles.tabsContainer}>

        {tabs.map((tab, index) => {
          const isTabSelected = index === selectedIndex
          return (
            <Button
              key={index}
              className={cl(styles.tab, {
                [styles.tabSelected]: isTabSelected
              })}
              onClick={() => setSelectedIndex(index)}
            >
              {customTabComponent
                ? customTabComponent(tab)
                : (
                  <Text1
                    overflowEllipsis
                    bold={isTabSelected && boldSelectedTab}
                  >
                    {capitalizeTabs ? capitalize(tab as any) : tab}
                  </Text1>
                )}
            </Button>
          )
        })}

      </div>
      <HorizontalLine style={{ marginTop: -3 }} />
      {children}
    </div>
  )
}

const TabsLine = TabsLineComponent
export { TabsLine }
